import { atom, selector, useRecoilState } from "recoil";
import { orderDetailRealmType } from "./type";
import ApiController from "../controller/ApiController";
import { getRecoil } from "recoil-nexus";
import { authState, masterStoreState } from "./auth";
import LogController from "../controller/LogController";

export type cartPayInfo = {
  total_amount_org: number;
  total_amount_incl: number;
  tax: number;
  discount_amount: number;
};

export const cartState = atom<orderDetailRealmType[]>({
  key: "cart",
  default: [],
});

export const inquiryState = atom<string>({
  key: "inquiry",
  default: "",
});

export const cartPayInfoState = selector<cartPayInfo>({
  key: "cartPayInfo",

  get: ({ get }) => {
    const cartProductListData = get(cartState);

    let priceInfoObj: cartPayInfo = {
      total_amount_org: 0,
      total_amount_incl: 0,
      tax: 0,
      discount_amount: 0,
    };

    let prdName = "";
    for (let i = 0; i < cartProductListData.length; i++) {
      prdName =
        prdName +
        `${cartProductListData[i].product_name} ${cartProductListData[i].product_quantity}개 `;
      console.log(i, cartProductListData[i].product_discount_amount);
      // priceInfoObj.discount_amount +=
      //   cartProductListData[i].product_discount_amount *
      //   cartProductListData[i].product_quantity;
      priceInfoObj.tax += 0;
      priceInfoObj.total_amount_incl +=
        cartProductListData[i].product_total_amount;
      priceInfoObj.discount_amount +=
        cartProductListData[i].product_discount_amount;
      priceInfoObj.total_amount_org +=
        cartProductListData[i].product_discount_amount +
        cartProductListData[i].product_total_amount;
      console.log(
        `${cartProductListData[i].product_name} : ${cartProductListData[i].product_total_amount}`
      );
      // for (let j = 0; j < cartProductListData[i].options.length; j++) {
      //   console.log(`${cartProductListData[i].product_name} ==>> ${cartProductListData[i].options[j].option_name}: ${cartProductListData[i].options[j].option_price}`)
      //   priceInfoObj.total_amount_incl += cartProductListData[i].options[j].option_price;
      // }

      // for(let j =0; j<cartProductListData[i].set_product.length; j++){
      //   const pickProductGroup = cartProductListData[i].set_product[j];

      //   for(let k =0; k<pickProductGroup.pick.length; k++){
      //     const pickProduct = pickProductGroup.pick[k];
      //     priceInfoObj.total_amount_incl += pickProduct.prd_price;

      //     for (let l = 0; l < pickProduct.pick.length; l++) {
      //       for (let z = 0; z < pickProduct.pick[l].length; z++) {
      //         const pickOption = pickProduct.option_group_list[l].option_list[z];
      //         priceInfoObj.total_amount_incl += pickOption.option_price;
      //       }
      //     }
      //   }

      // }

      // for (let j = 0; j < cartProductListData[i].products.length; j++) {
      //   priceInfoObj.total_amount_incl +=cartProductListData[i].products[j].product_total_amount;

      //   for (let k = 0; k < cartProductListData[i].products[j].options.length; k++) {
      //     priceInfoObj.total_amount_incl += cartProductListData[i].products[j].options[k].option_price;
      //   }
      // }
    }

    try {
      LogController.event({
        path: "Cart",
        params: "cart",
        params2: `${prdName === "" ? "비움" : prdName}, prise: ${
          priceInfoObj.total_amount_incl
        }`,
        store_id:
          cartProductListData.length > 0 ? cartProductListData[0].store_id : 0,
        index:
          cartProductListData.length > 0 ? cartProductListData[0].store_id : 0,
      });
    } catch (err) {
      console.log(err);
    }

    return priceInfoObj;
  },
});

export const cartProductQuantityState = selector<number>({
  key: "cartProductQuantityList",
  get: ({ get }) => {
    const cartProductListData = get(cartState);

    let totalOrder = 0;

    for (let i = 0; i < cartProductListData.length; i++) {
      totalOrder += cartProductListData[i].product_quantity;
    }

    return totalOrder;
  },
});
